export default {
  switcher: "Кабинеты",
  loadFailed: "Не удалось загрузить список кабинетов.",
  reader: "Читатель",
  writer: "Писатель",
  organizer: "Организатор",
  union: "Союз",
  catalog: "Каталогизация",
  administrator: "Администратор",
  analytics: "Аналитика",
  profile: "Профиль",
  summary: "Сводка",
  myCabinets: "Мои кабинеты",
  openSidebar: "Открыть меню кабинета",
  closeSidebar: "Закрыть меню кабинета",
  nav: {
    profile: "Профиль",
    overview: "Обзор",
    anketa: "Анкета и пароль",
    analyticsOverview: "Обзор",
  },
  groups: {
    sections: "Разделы",
    management: "Управление",
    administration: "Администрирование",
    audit: "Аудит",
  },
  summaryPage: {
    title: "Сводка",
    subtitle: "Все ваши роли на одном экране. Выберите кабинет, чтобы продолжить работу.",
    open: "Открыть кабинет",
    pending_one: "{{count}} задача ждёт внимания",
    pending_few: "{{count}} задачи ждут внимания",
    pending_many: "{{count}} задач ждут внимания",
    pending_other: "{{count}} задачи ждут внимания",
    nothingPending: "Новых задач нет",
    profileHint: "Анкета, уведомления и записи на мероприятия.",
  },
  hints: {
    reader: "Записи на мероприятия, коллекции, уведомления и анкета.",
    writer: "Анкета писателя, портфолио, заявка в Союз и депонирование.",
    organizer: "Создание мероприятий, посещаемость и модерация.",
    union: "Заявки на вступление, реестр членов и верификация произведений.",
    catalog: "Записи каталога, ошибки, словари, импорт, модерация и статистика.",
    administrator: "Пользователи, роли, ассоциации и журналы аудита.",
    analytics: "Статистика каталога и портала.",
  },
  pendingBadge: "Задач: {{count}}",
}
